/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceDetailResponse {
    getFixupPrototypeFunction() { return InfraResourceDetailResponse.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceDetailResponse>): InfraResourceDetailResponse {
        let obj = Object.assign(new InfraResourceDetailResponse(), model);
        InfraResourceDetailResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceDetailResponse>): InfraResourceDetailResponse {
        if (!model) return null;
        return InfraResourceDetailResponse.newInstance(<InfraResourceDetailResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceDetailResponse) {
        if (!obj) return;

        models.InfraResourceDetailResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceDetailResponse): boolean {
        Object.setPrototypeOf(obj, InfraResourceDetailResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
    }

    /**
     * Canonical resource type (e.g. ComputeInstance, VirtualNetwork).
     */
    canonical_type: string;

    /**
     * Timestamp when the resource was first discovered.
     */
    created_at: Date;

    /**
     * All canonical properties for this resource type. Keys vary by canonical_type (e.g. instanceType, vCpus for ComputeInstance; addressSpace for VirtualNetwork).
     */
    attributes: any;

}
